<template>
  <div 
    class="relative text-white shadow-md rounded-xl p-6 text-center group"
    :style="panelStyle"
  >
    <div class="absolute top-4 right-4 bg-white/20 p-2 rounded-lg transition-transform duration-300 ease-in-out group-hover:scale-110 group-hover:rotate-6">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
    </div>
    <div v-if="user">
      <img v-if="user.photoURL" :src="user.photoURL" class="h-24 w-24 rounded-full object-cover mx-auto border-4 border-white/50">
      <div v-else class="h-24 w-24 rounded-full bg-gray-200 flex items-center justify-center font-bold text-gray-500 text-5xl mx-auto border-4 border-white/50">{{ displayName ? displayName.charAt(0).toUpperCase() : '' }}</div>
      <h2 class="mt-4 text-2xl font-bold">{{ displayName }}</h2>
      <p class="text-sm opacity-80">{{ userEmail }}</p>
      <div class="mt-4 flex items-center justify-center space-x-2">
        <router-link to="/profile" class="bg-white/20 px-4 py-2 rounded-md hover:bg-white/30 text-sm font-semibold">Edit Profile</router-link>
        <button @click="logout" class="bg-red-500/50 px-4 py-2 rounded-md hover:bg-red-500/70 text-sm font-semibold">Logout</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { auth } from '@/firebase';
import { signOut } from 'firebase/auth';

export default {
  name: 'ProfilePanel',
  computed: {
    ...mapState(['user']),
    ...mapGetters(['displayName', 'userEmail']),
    panelStyle() {
      const topColor = '#FED803';
      const bottomColor = '#D91C5E';
      return {
        backgroundImage: `linear-gradient(to bottom, ${topColor}, ${bottomColor})`,
      };
    }
  },
  methods: {
    // --- START: THE DEFINITIVE, FINAL FIX ---
    async logout() {
      try {
        await signOut(auth);
        // Force a hard reload to the login page. This clears all state.
        window.location.href = '/login';
      } catch (error) {
        console.error('Error signing out:', error);
        // As a fallback, still try to force the reload.
        window.location.href = '/login';
      }
    }
    // --- END: THE DEFINITIVE, FINAL FIX ---
  }
}
</script>